export const getYoutubeEmbedLink = (youtubeId: string) => {
  return `https://www.youtube.com/embed/${youtubeId}`;
};

export const getYoutubeWebLink = (youtubeId: string) => {
  return `https://www.youtube.com/watch?v=${youtubeId}`;
};
